import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrl: "./navbar.component.scss",
    standalone: false,
})
export class NavbarComponent {
    @Input() public showMenu: boolean = false;
    @Output() showMenuChange = new EventEmitter<boolean>();

    onShowMenuChange(value: boolean): void {
        this.showMenu = value;
        this.showMenuChange.emit(value);
    }
}
